export default __webpack_public_path__ + "static/media/broomfield-openspaces.75995bfd.woff";